import { Component, OnInit, Input, HostListener, ViewChild, ElementRef, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { Observable, forkJoin, Subscription } from 'rxjs';
import { ZoomApprenant, ZoomModel, ZoomUser, CustomSelect, ZoomUserGroup, ZoomMeeting, ModelMail, ZoomBoProperties } from '../models';
import { CoreService, HttpService } from '../services';
import { ToastService } from '../toast';
import { DialogService } from '../dialog';

export enum modes {
  create = 'CREATE',
  update = 'UPDATE',
}


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-zoom',
  templateUrl: './zoom.component.html',
  styleUrls: ['./zoom.component.css'],
})

export class ZoomComponent implements OnInit {

  // #region VARIABLES GLOBALES
  public model: ZoomModel = new ZoomModel();
  public modelTampon: ZoomMeeting = new ZoomMeeting();
  public modelHasChanged: boolean = false;
  // animateurs supplémentaires
  public alternativeHostsSelected: number = -1;
  public modes: typeof modes = modes;
  public idBo: string;
  public idMeeting: string;
  public mode: string = modes.create;
  public isOptions: boolean = false;
  public checkedAll: boolean = true;

  public selectedModelEmpty: boolean = false;
  public selectedModelMail: string = '';
  public listModelsMail: ModelMail[] = [];
  private sub: Subscription;
  private ObjectIsClicked: boolean = false;

  public isSaving: boolean = false;

  public listAnimateurs: Array<ZoomApprenant> = new Array<ZoomApprenant>();
  private EntryPointEmail: string = '';
  private EntryPointIdent: string = '';
  public forceHiddeListAnimateurs: boolean = false;

  public options: Array<CustomSelect> = [
    // { Selected: this.properties.meeting.type === 1 ? true : false, Text: 'réunion instantanée', Value: 1 },
    { Selected: this.model.Meeting.type === 2 ? true : false, Text: 'réunion', Value: 2 },
    // { Selected: this.properties.meeting.type === 3 ? true : false, Text: 'réunion récurente sans heure fixe', Value: 3 },
    // { Selected: this.properties.meeting.type === 8 ? true : false, Text: 'réunion récurente (à heure fixe)', Value: 8 },
    { Selected: this.model.Meeting.type === 5 ? true : false, Text: 'webinaire', Value: 5 }
    // { Selected: this.properties.meeting.type === 6 ? true : false, Text: 'wébinaire récurent sans heure fixe', Value: 6 },
    // { Selected: this.properties.meeting.type === 9 ? true : false, Text: 'webinaire récurent (à heure fixe)', Value: 9 },
  ];

  public listMailLoaded: boolean = false;
  // #endregion

  // #region DIRECTIVES


  // tslint:disable-next-line:no-input-rename
  @Input('IdBO')
  set IdBO(value: string) {
    this.idBo = value;
  }
  @Input('IdUser')
  set IdUser(value: string) {
    // this.model.userOfAgenda.strIdent = value ? value : '';
    this.EntryPointIdent = value ? value : '';
    if (this.EntryPointIdent) {
      this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_EMAIL_ZOOM_BY_ID_USER/${this.EntryPointIdent}`).subscribe((result: ZoomModel) => {
        if (!result.HasError) {
          //this.model.userOfAgenda.strZoomEmail = result.userOfAgenda.strZoomEmail;
          this.EntryPointEmail = result.userOfAgenda.strZoomEmail;
        }
      });
    }
  }

  @Input('IdMeeting')
  set modelZoom(value: string) {
    this.idMeeting = value;
  }

  @Output() Url: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild('StatutContent', { static: false }) StatutContent: ElementRef;

  @ViewChild('openModalDelete', { static: false }) openModalDelete: ElementRef;
  @ViewChild('closeModalDelete', { static: false }) closeModalDelete: ElementRef;

  @ViewChild('closeModalMail', { static: false }) closeModalMail: ElementRef;

  @HostListener('click', ['$event'])
  public closeHelpsModals(e: any): void {
    if (!this.ObjectIsClicked) {
      this.StatutContent.nativeElement.classList.remove('active');
    }
  }

  // #endregion

  // #region CONSTRUCTEUR
  constructor(
    private httpService: HttpService,
    private indParam: CoreService,
    private dialogservice: DialogService,
    private toastservice: ToastService,
    public cd: ChangeDetectorRef
  ) { }
  // #endregion

  // #region CYCLE DE VIE

  ngOnInit(): void {
    
    this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_LIST_MODEL_EMAIL/${this.idBo}`).subscribe((result: ZoomModel) => {
      this.listModelsMail = result.MailModel.ListModelsMail;
      if (this.listModelsMail.length > 0) {
        this.selectedModelMail = this.listModelsMail[0].CodeModel;
      }
      this.listMailLoaded = true;
    });
    if (this.idBo) {
      this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_MEETING_FROM_BO/${this.idBo}`).subscribe((result: ZoomModel) => {
        this.model.Meeting = result.Meeting;
        this.model.start_time_bo = result.start_time_bo;
        this.model.duration_bo = result.duration_bo;
        this.model.Meeting.start_time = new Date(new Date(this.model.Meeting.start_time).toUTCString()).toISOString().replace('.000Z', 'Z');
        //this.model.Meeting.timezone = this.indParam.AppParams.localTimeZone;
        if (result.userOfAgenda.strIdent || result.userOfAgenda.strZoomEmail) {
          this.model.userOfAgenda = result.userOfAgenda;
        }
        this.modelTampon = JSON.parse(JSON.stringify(result.Meeting));
        if (this.model.Meeting.id) {
          this.idMeeting = this.model.Meeting.id;
          this.mode = modes.update;
        }
        this.GetListHost();
        this.selectOption();
        this.GetContacts();
      });
    } else if (this.idMeeting) {
      this.mode = modes.update;
      this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_MEETING_FROM_ZOOM_BY_ID/${this.idMeeting}|${this.idBo}`).subscribe((result: ZoomModel) => {
        this.model.Meeting = result.Meeting;
        this.model.Meeting.start_time = new Date(new Date(this.model.Meeting.start_time).toUTCString()).toISOString().replace('.000Z', 'Z');
        if (result.userOfAgenda.strIdent || result.userOfAgenda.strZoomEmail) {
          this.model.userOfAgenda = result.userOfAgenda;
        }
        if (!this.model.userOfAgenda.strIdent && !this.model.userOfAgenda.strZoomEmail) {
          this.toastservice.showAlertToast(`Aucun animateur n'a été trouvé`);
        }
        this.modelTampon = JSON.parse(JSON.stringify(result.Meeting));
        this.selectOption();
      });
      this.GetContacts();
    } else {
      if (!this.model.userOfAgenda.strIdent && !this.model.userOfAgenda.strZoomEmail) {
        this.toastservice.showAlertToast(`Aucun animateur n'a été trouvé`);
      }
    }
  }

  private GetListHost(): void {

    if (this.idBo) {
      this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_ANIMATEUR_BY_ID_BO/${this.idBo}`).subscribe((result: ZoomModel) => {
        if (this.model.userOfAgenda.strIdent || this.model.userOfAgenda.strZoomEmail) {
          this.forceHiddeListAnimateurs = true;
        }
        if (
          result && result.ZoomEventsModel && result.ZoomEventsModel.ListZoomApprenant && result.ZoomEventsModel.ListZoomApprenant.length > 0
          && (result.ZoomEventsModel.ListZoomApprenant[0].strIdent || result.ZoomEventsModel.ListZoomApprenant[0].strEmail)
        ) {
          if (result.ZoomEventsModel.ListZoomApprenant.length > 1) {
            this.listAnimateurs = result.ZoomEventsModel.ListZoomApprenant;
            const emptyLine: ZoomApprenant = new ZoomApprenant();
            emptyLine.check = true;
            this.listAnimateurs.unshift(emptyLine);
            let i: number = this.listAnimateurs.findIndex(a => a.strEmail === (this.forceHiddeListAnimateurs ? this.model.userOfAgenda.strZoomEmail : this.EntryPointEmail));
            i = i === -1 ? 0 : i;
            this.model.userOfAgenda.strIdent = this.listAnimateurs[i].strIdent;
            this.model.userOfAgenda.strZoomEmail = this.listAnimateurs[i].strEmail;
            for (let j: number = 0; j < this.listAnimateurs.length; j++) {
              this.listAnimateurs[j].check = false;
              if (this.listAnimateurs[i].strIdent === this.listAnimateurs[j].strIdent) {
                this.listAnimateurs[j].check = true;
              }
            }
          } else {
            this.model.userOfAgenda.strIdent = result.ZoomEventsModel.ListZoomApprenant[0].strIdent;
            this.model.userOfAgenda.strZoomEmail = result.ZoomEventsModel.ListZoomApprenant[0].strEmail;
            this.model.userOfAgenda.strNeproPER = `${result.ZoomEventsModel.ListZoomApprenant[0].strNom}${result.ZoomEventsModel.ListZoomApprenant[0].strNom ? ' ' : ''}${ result.ZoomEventsModel.ListZoomApprenant[0].strPrenom }`;
          }
        } else {
          this.toastservice.showAlertToast(`Aucun animateur n'a été trouvé`);
        }
      });
    }
  }

  public ValidEmail(contact: ZoomApprenant): void {
    //String@String.String
    const re: RegExp = /\S+@\S+\.\S+/;
    if (!re.test(contact.strEmail)) {
      contact.check = false;
      contact.isValid = false;
    }
  }

  public openMailModal(): void {
    if (this.listMailLoaded) {
      this.indParam.showSplash(false);
    } else {
      this.indParam.showSplash(true);
      setTimeout(() => {
        this.openMailModal();
      }, 100);
    }
  }

  public participantsSelected(): boolean {
    for (const el of this.model.ZoomEventsModel.ListZoomApprenant) {
      if (el.check) {
        return false;
      }
    }
    return true;
  }

  public checkAll(): void {
    this.checkedAll = this.model.ZoomEventsModel.ListZoomApprenant.filter((contact: ZoomApprenant) => !contact.check && contact.isValid).length > 0;
    this.model.ZoomEventsModel.ListZoomApprenant.forEach((zoomElement: ZoomApprenant) => {
      if (zoomElement.isValid) {
        zoomElement.check = this.checkedAll;
      }
    });
    setTimeout(() => {
      this.cd.detectChanges();
    }, 0);
  }

  public SendCustomMails(): void {
    if (this.selectedModelMail === '') {
      this.selectedModelEmpty = true;
      this.toastservice.showAlertToast(`veuillez sélectionner un model d'email`);
    } else {
      const model: ZoomModel = new ZoomModel();
      model.ZoomEventsModel.ListZoomApprenant = new Array<ZoomApprenant>();
      this.model.ZoomEventsModel.ListZoomApprenant.forEach((app: ZoomApprenant) => {
        if (app.check) {
          model.ZoomEventsModel.ListZoomApprenant.push(app);
        }
      });
      this.indParam.showSplash(true);
      model.Mode = 'SEND_CUSTOM_MAIL';
      model.MailModel.ModelMailSelected.CodeModel = this.selectedModelMail;
      model.userOfAgenda.strIdent = this.model.userOfAgenda.strIdent;
      model.ZoomBoProperties = new ZoomBoProperties();
      model.ZoomBoProperties.idBoFils = this.idBo;
      this.httpService.postHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/`, model).subscribe((result: ZoomModel) => {
        this.indParam.showSplash(false);
        this.closeModalMail.nativeElement.click();
      });
    }
  }

  public check(index: number): void {
    this.model.ZoomEventsModel.ListZoomApprenant[index].check = !this.model.ZoomEventsModel.ListZoomApprenant[index].check;
    this.checkedAll = this.model.ZoomEventsModel.ListZoomApprenant.filter((contact: ZoomApprenant) => contact.check).length === this.model.ZoomEventsModel.ListZoomApprenant.filter((contact: ZoomApprenant) => contact.isValid).length;
    setTimeout(() => {
      this.cd.detectChanges();
    }, 0);
  }


  public SelectAnimateur(value: string): void {
    const ident: string = value.split('|')[0];
    const email: string = value.split('|')[1];
    this.model.userOfAgenda.strZoomEmail = email;
    this.model.userOfAgenda.strIdent = ident;
    for (let i: number = 0; i < this.listAnimateurs.length; i++) {
      if (this.listAnimateurs[i].strEmail === email) {
        this.listAnimateurs[i].check = true;
      } else {
        this.listAnimateurs[i].check = false;
      }
    }
  }

  public selectOption(value: string | null = null): void {
    if (value) {
      this.model.Meeting.type = Number(value);
    }
    for (let i: number = 0; i < this.options.length; i++) {
      if (this.options[i].Value === this.model.Meeting.type) {
        this.options[i].Selected = true;
      } else {
        this.options[i].Selected = false;
      }
    }
  }
  // #endregion
  public updateStartTime(newDateDebut: string, newDuration: number | null): void {
    if (newDateDebut) {
      this.model.Meeting.start_time = newDateDebut;
    }
    if (newDuration) {
      this.model.Meeting.duration = newDuration;
    }
    this.SaveMeeting(() => { this.model.start_time_bo = ''; this.model.duration_bo = null; });
  }

  public SaveMeeting(callback: any = null): void {
    if (!this.model.userOfAgenda.strIdent && !this.model.userOfAgenda.strZoomEmail) {
      this.toastservice.showWarningToast('sélectionnez un animateur avant de pouvoir poursuivre');
    }
    else {
      this.dialogservice.showSplash(true);
      if (this.isSaving) {
        this.dialogservice.showSplash(false);
        return;
      }
      this.isSaving = true;
      //#region valeus par défaut des options non proposées dans les options avancées COTE SERVEUR
      //////const defaultSettings: ZoomMeetingSetting = new ZoomMeetingSetting();
      //////// Options propres aux meetings
      //////if (this.model.Meeting.type === 1 || this.model.Meeting.type === 2 || this.model.Meeting.type === 3 || this.model.Meeting.type === 8) {
      //////  this.model.Meeting.settings.participant_video = defaultSettings.participant_video;
      //////}

      //////// Options propres aux webinaires
      //////if (this.model.Meeting.type === 5 || this.model.Meeting.type === 6 || this.model.Meeting.type === 9) {
      //////  this.model.Meeting.settings.panelists_video = defaultSettings.panelists_video;
      //////  this.model.Meeting.settings.practice_session = defaultSettings.practice_session;
      //////  this.model.Meeting.settings.hd_video = defaultSettings.hd_video;
      //////  this.model.Meeting.settings.close_registration = defaultSettings.close_registration;
      //////  this.model.Meeting.settings.show_share_button = defaultSettings.show_share_button;
      //////  this.model.Meeting.settings.allow_multiple_devices = defaultSettings.allow_multiple_devices;
      //////}

      //////// Options communes:
      //////this.model.Meeting.settings.cn_meeting = defaultSettings.cn_meeting;
      //////this.model.Meeting.settings.in_meeting = defaultSettings.in_meeting;
      //////this.model.Meeting.settings.watermark = defaultSettings.watermark;
      //////this.model.Meeting.settings.use_pmi = defaultSettings.use_pmi;
      //////this.model.Meeting.settings.approval_type = defaultSettings.approval_type;
      //////this.model.Meeting.settings.registration_type = defaultSettings.registration_type;
      //////this.model.Meeting.settings.audio = defaultSettings.audio;
      //////this.model.Meeting.settings.auto_recording = defaultSettings.auto_recording;
      //////this.model.Meeting.settings.enforce_login = defaultSettings.enforce_login;
      //////this.model.Meeting.settings.enforce_login_domains = defaultSettings.enforce_login_domains;
      //////this.model.Meeting.settings.alternative_hosts = defaultSettings.alternative_hosts;
      //#endregion
      this.modelHasChanged = JSON.stringify(this.modelTampon) !== JSON.stringify(this.model.Meeting);
      this.mode = this.model.Meeting.id ? modes.update : modes.create;

      if (this.mode === modes.create) {
        this.model.Mode = 'CREATE_MEETING';

      } else if (this.mode === modes.update) {
        this.model.Mode = 'UPDATE_MEETING';
      }
      this.model.ZoomBoProperties.idBoFils = this.idBo;
      if (!this.modelHasChanged && this.mode !== modes.create) {
        this.dialogservice.showSplash(false);
        return;
      }
      this.httpService.postHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/`, this.model).subscribe(
        (result: ZoomModel) => {
          try {
            this.idMeeting = result.Meeting.id;
            if (!this.idMeeting) {
              this.dialogservice.showSplash(false);
              this.isSaving = false;
              return;
            }

            this.forceHiddeListAnimateurs = true;

            if (result.userOfAgenda)
              this.model.userOfAgenda = result.userOfAgenda;

            if (this.mode === modes.create) {
              this.Url.emit(result.Meeting.join_url);
            }
            this.mode = modes.update;
            this.model.Meeting = result.Meeting;
            this.selectOption(`${result.Meeting.type}`);
            this.model.Meeting.start_time = new Date(new Date(this.model.Meeting.start_time).toUTCString()).toISOString().replace('.000Z', 'Z');
            this.modelTampon = JSON.parse(JSON.stringify(result.Meeting));
            if (callback) {
              callback();
            }

            if (this.idBo && this.idBo !== '0' && this.model.Meeting.join_url) {
              this.Url.emit(this.model.Meeting.join_url);
              this.dialogservice.showSplash(false);
            } else {
              this.toastservice.showWarningToast(this.indParam.getTrad('backBookingToFinaliseIt'));
              this.dialogservice.showSplash(false);
            }

            this.isSaving = false;
          }
          catch (e) {
            this.dialogservice.showSplash(false);
          }
          }      
      );
    }
  }

  public disabledSaveMeetingButton(): boolean {
    return !(JSON.stringify(this.modelTampon) !== JSON.stringify(this.model.Meeting) || this.mode === modes.create);
  }

  public closeDelete(): void {
    this.closeModalDelete.nativeElement.click();
  }

  public OpenDelete(): void {
    this.openModalDelete.nativeElement.click();
  }

  public onOpenTooltipHelp(): void {
    this.ObjectIsClicked = true;
    this.StatutContent.nativeElement.classList.toggle('active');
    setTimeout(() => {
      this.ObjectIsClicked = false;
    }, 0.25);
  }

  public OnSendingInvitaions(): void {

    this.dialogservice.showSplash(true);

    const guestsToInvit: ZoomUserGroup = new ZoomUserGroup;

    this.model.ZoomEventsModel.ListZoomApprenant.forEach((contact: ZoomApprenant) => {
      const guest: ZoomUser = {
        email: contact.strEmail,
        first_name: contact.strPrenom,
        id: contact.strIdent,
        last_name: contact.strNom,
        type: 1,
        password: '',
        registrant_id: ''
      };
      if (contact.etat === '3-add' && contact.strEmail && contact.check) {
        guestsToInvit.registrants.push(guest);
      }
    });

    if (guestsToInvit.registrants.length < 1) {
      this.toastservice.showInfoToast('Aucun nouveau contact à inviter à la réunion');
      this.dialogservice.showSplash(false);

    } else {
      const zoom: ZoomModel = new ZoomModel();
      zoom.UserGroup = guestsToInvit;
      zoom.ZoomBoProperties = new ZoomBoProperties();
      zoom.ZoomBoProperties.idBoFils = this.idBo;
      // si on n'a pas d'id de meeting on créé la salle avant d'envoyer les invitations
      if (!this.model || !this.model.Meeting || !this.model.Meeting.id || JSON.stringify(this.modelTampon) !== JSON.stringify(this.model.Meeting)) {
        this.SaveMeeting(() => {
          this.dialogservice.showSplash(true);
          zoom.Meeting = this.model.Meeting;
          zoom.Mode = 'ADD_REGISTRANTS';

          this.httpService.postHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/`, zoom).subscribe((result: ZoomModel) => {
            this.GetContacts();
            this.dialogservice.showSplash(false);
          });
        });
        this.dialogservice.showSplash(false);

      }
      // sinon on envoi les invitations
      else {
        zoom.Meeting = this.model.Meeting;
        zoom.Mode = 'ADD_REGISTRANTS';

        this.httpService.postHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/`, zoom).subscribe((result: ZoomModel) => {
          this.GetContacts();
          this.dialogservice.showSplash(false);
        });
      }
    }


  }

  public OnDeleteMeeting(id: string): void {
    this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/DELETE_MEETING/${id}|${this.idBo}`).subscribe(
      () => {
        this.forceHiddeListAnimateurs = false;
        this.mode = modes.create;
        this.Url.emit('');
        this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_MEETING_FROM_BO/${this.idBo}`).subscribe((result: ZoomModel) => {
          this.model.Meeting = result.Meeting;
          this.model.start_time_bo = result.start_time_bo;
          this.model.duration_bo = result.duration_bo;
          this.model.Meeting.start_time = new Date(new Date(this.model.Meeting.start_time).toUTCString()).toISOString().replace('.000Z', 'Z');
          this.modelTampon = JSON.parse(JSON.stringify(result.Meeting));

          this.selectOption();
          this.GetContacts();
        });

      });
  }
  // #region FONCTIONS PUBLIQUES



  // #endregion

  // #region FONCTIONS PRIVEES



  private GetContacts(): void {
    this.dialogservice.showSplash(true);
    // initialisation de l'index des subscriptions
    let index: number = 0;
    const subs: Array<Observable<ZoomModel>> = [];
    //#region souscriptions de récupération des contacts
    // historique des indexs de chaque subscription optionnelle
    const IndexSubsGetContactsFrom: { zoomAPI: number | null, resa: number | null } = { zoomAPI: null, resa: null };

    this.model.ZoomEventsModel.ListZoomApprenant = [];

    if (this.model.Meeting.id) {
      this.mode = modes.update;
      IndexSubsGetContactsFrom.zoomAPI = index;
      index++;
      subs.push(this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_CONTACTS_FROM_ZOOM_BY_MEETING_ID/${this.model.Meeting.id}`));
    }

    // si il y a une subscription pour getContactsResa, on sauvegarde l'index auquel il sera poussé
    //dans la liste de subs(plus bas) et on incrémente de +1 l'index
    if (this.idBo) {
      IndexSubsGetContactsFrom.resa = index;
      index++;
      subs.push(this.httpService.getHttp<ZoomModel>(`${this.indParam.AppParams.apiUrl}api/zoom/GET_CONTACT_BY_ID_BO/${this.idBo}`));
    }

    this.sub = forkJoin(subs).subscribe((result2: Array<ZoomModel>) => {
      let arrayContacts: Array<ZoomApprenant> = [];
      // récupération du résult de getContactsResa grâce à l'index conservé dans l'historique IndexSubs
      if (IndexSubsGetContactsFrom.resa !== null) {
        const resContacts: ZoomModel = result2[IndexSubsGetContactsFrom.resa];
        if (resContacts && !resContacts.HasError && resContacts.ZoomEventsModel) {
          arrayContacts = arrayContacts.concat(resContacts.ZoomEventsModel.ListZoomApprenant);
        }
      }

      if (IndexSubsGetContactsFrom.zoomAPI !== null) {
        const resContacts: ZoomModel = result2[IndexSubsGetContactsFrom.zoomAPI];
        if (resContacts && !resContacts.HasError && resContacts.ZoomEventsModel) {
          arrayContacts = arrayContacts.concat(resContacts.ZoomEventsModel.ListZoomApprenant);
        }
      }
      // ajoute arrayContacts au model en retirant les doublons entre Web.API et l'API Zoom en conservant le contact d'API Zoom en priorité
      arrayContacts.forEach((contact: ZoomApprenant) => {
        const indexOfSameContactInModel: number = this.model.ZoomEventsModel.ListZoomApprenant.findIndex((c: ZoomApprenant) => contact.strEmail === c.strEmail && contact.strNom === c.strNom && contact.strPrenom === c.strPrenom);

        // si le contact ne possède pas un ident de la tdoPersonne déjà présent dans la liste
        if (this.model.ZoomEventsModel.ListZoomApprenant.filter((c: ZoomApprenant) => c.strIdent === contact.strIdent).length < 1) {
          //mais  qu'il y a un doublon dans le model
          if (indexOfSameContactInModel !== -1) {
            //et qu'il ne possède pas d'id de l'api zoom
            if (!this.model.ZoomEventsModel.ListZoomApprenant[indexOfSameContactInModel].strIdZoomAPI) {
              // on ajoute l'id du contact doublon (qu'importe qu'il y en ai un ou non) ainsi que son état.
              this.model.ZoomEventsModel.ListZoomApprenant[indexOfSameContactInModel].strIdZoomAPI = contact.strIdZoomAPI;
              this.model.ZoomEventsModel.ListZoomApprenant[indexOfSameContactInModel].etat = contact.etat;
            }
            //ou qu'il ne possède pas d'id de la TDOPErsonne
            if (!this.model.ZoomEventsModel.ListZoomApprenant[indexOfSameContactInModel].strIdent) {
              // on ajoute l'id du contact doublon (qu'importe qu'il y en ai un ou non)
              this.model.ZoomEventsModel.ListZoomApprenant[indexOfSameContactInModel].strIdent = contact.strIdent;
            }
          }
          // si il n'y a pas de doublon on ajout le contact au model
          else {
            this.ValidEmail(contact);
            this.model.ZoomEventsModel.ListZoomApprenant.push(contact);
          }
        }
      });
      this.model.ZoomEventsModel.ListZoomApprenant.sort((app1: ZoomApprenant, app2: ZoomApprenant) => {
        
        return app1.etat.toLowerCase().localeCompare(app2.etat.toLowerCase())
          || app1.strNom.toLowerCase().localeCompare(app2.strNom.toLowerCase())
          || app1.strPrenom.toLowerCase().localeCompare(app2.strPrenom.toLowerCase());
      });
      this.checkedAll = true;
      this.dialogservice.showSplash(false);
    });

  }


}

